var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"extended-panel details-panel routed-extended-page"},[(_vm.truck)?_c('planner-panel',{staticClass:"side-panel-fill",attrs:{"truck":_vm.truck},on:{"lostfocus":_vm.goToTruckDetails}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }